import { render, staticRenderFns } from "./fifthPage.vue?vue&type=template&id=152199f0"
import script from "./fifthPage.vue?vue&type=script&lang=js"
export * from "./fifthPage.vue?vue&type=script&lang=js"
import style0 from "./fifthPage.vue?vue&type=style&index=0&id=152199f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports